import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "../../../table/Column";
import { CellRenderer } from "./CellRenderer";
import { Table } from "../../../table/Table";
import { parseDate, normalizeString } from "./utils/helpers";
import { Radio } from "./styles";
export const SimilarResidentsTable = ({ similarResidents = [], activeRowId = "", selectable = true, residentFilesModal, formValues, }) => {
    return (_jsxs(Table, { data: similarResidents.filter(resident => resident.match !== "100%"), activeRowId: activeRowId, getRowId: ({ rowData }) => rowData.resident.id, children: [_jsx(Column, { cellRenderer: ({ rowData }) => (_jsx(Radio, { visible: 
                    // Not selectable when creating new resident through form
                    selectable, onClick: (e) => {
                        e.stopPropagation();
                    }, name: "resident_demographics.similar_resident", type: "radio", value: rowData.resident.id })), width: 100 }), _jsx(Column, { cellRenderer: ({ rowData }) => {
                    return CellRenderer({
                        label: "First name",
                        value: rowData.resident.first_name || "—",
                    }, normalizeString(formValues.first_name) ===
                        normalizeString(rowData.resident.first_name));
                }, label: "First Name", width: 250 }), _jsx(Column, { cellRenderer: ({ rowData }) => {
                    return CellRenderer({
                        label: "Last name",
                        value: rowData.resident.last_name || "—",
                    }, normalizeString(formValues.last_name) ===
                        normalizeString(rowData.resident.last_name));
                }, label: "Last Name", width: 250 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({ label: "Gender", value: rowData.resident.gender || "—" }, formValues.gender === rowData.resident.gender), label: "Gender", width: 150 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({
                    label: "Date of birth",
                    value: rowData.resident.date_of_birth
                        ? parseDate(rowData.resident.date_of_birth)
                        : "—",
                }, formValues.date_of_birth === rowData.resident.date_of_birth), label: "Date of Birth", width: 150 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({
                    label: "Resident ID",
                    value: rowData.resident.resident_id || "—",
                }, true), label: "Resident ID", width: 150 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({
                    label: "EHR ID",
                    value: rowData.resident.pcc_patient_id || "—",
                }, true), label: "EHR ID", width: 150 }), _jsx(Column, { cellRenderer: ({ rowData }) => CellRenderer({
                    label: "MRN",
                    value: rowData.resident.mrn || "—",
                }, true), label: "MRN", width: 150 }), _jsx(Column, { cellRenderer: ({ rowData, rowIndex }) => {
                    return (_jsx("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "16px",
                        }, children: residentFilesModal({
                            rowData,
                            rowIndex,
                        }) }));
                }, width: 150 })] }));
};
